/**
 * Per-request Emotion cache for SSR isolation.
 * Styles are inlined into SSR HTML by Emotion (see prerendered pages —
 * `<style data-emotion>` already present). CacheProvider avoids cross-request
 * style leakage when caches would otherwise be shared.
 */

import createCache, { type EmotionCache } from '@emotion/cache';

export const EMOTION_CACHE_KEY = 'css';

export function createEmotionCache(): EmotionCache {
  return createCache({ key: EMOTION_CACHE_KEY });
}
